const emailValidation = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

const RegexCode = {
    emailValidation,
    urlValidation,
};

export default RegexCode;
